import {AsyncActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/AsyncActDecorator';

export class ReelsInitAct extends AsyncActDecorator {
    public async execute(): Promise<void> {
        this.emitter.emit('General.Reels.SetupReelStrip');
    }

    getName(): string {
        return 'ReelsInitAct';
    }
}